// Mock data for Mapeach website

export const companyStats = [
  { label: "Average Time to Hire", value: "72 hours", icon: "clock" },
  { label: "Cost Savings vs Agencies", value: "Up to 20%", icon: "trending-down" },
  { label: "Vetted Professionals", value: "5,000+", icon: "users" },
  { label: "Client Satisfaction", value: "98%", icon: "star" }
];

export const clientLogos = [
  { name: "TechCorp", url: "https://via.placeholder.com/150x60/e2e8f0/64748b?text=TechCorp" },
  { name: "DataSystems", url: "https://via.placeholder.com/150x60/e2e8f0/64748b?text=DataSystems" },
  { name: "CloudInnovate", url: "https://via.placeholder.com/150x60/e2e8f0/64748b?text=CloudInnovate" },
  { name: "AIVentures", url: "https://via.placeholder.com/150x60/e2e8f0/64748b?text=AIVentures" }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "CTO, CloudScale Inc.",
    content: "Mapeach cut our hiring time from 3 weeks to 48 hours. The quality of talent and cost transparency is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    role: "VP Engineering, DataFlow Systems",
    content: "We saved over $250K annually by switching from traditional agencies to Mapeach. The automated compliance handling is a game-changer.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Johnson",
    role: "Head of Talent, FinTech Solutions",
    content: "The direct engagement model gives us complete control. No hidden fees, no surprises—just excellent talent delivered fast.",
    rating: 5
  }
];

export const talentTestimonials = [
  {
    id: 1,
    name: "Alex Kumar",
    role: "Senior Full-Stack Engineer",
    content: "I earn 30% more through Mapeach compared to traditional agencies. The platform makes contract and timesheet management seamless.",
    rating: 5
  },
  {
    id: 2,
    name: "Jessica Liu",
    role: "Cloud Architect",
    content: "Working with high-quality clients through Mapeach has accelerated my career. No middleman taking a huge cut of my rate.",
    rating: 5
  }
];

export const techDomains = {
  technical: [
    {
      id: 1,
      title: "AI/ML Engineers",
      description: "LLMs, GPT, Deep Learning, Neural Networks, PyTorch, TensorFlow"
    },
    {
      id: 2,
      title: "Cloud Architects",
      description: "AWS, Azure, GCP, Kubernetes, Docker, Microservices, Serverless"
    },
    {
      id: 3,
      title: "Full-Stack Developers",
      description: "React, Node.js, Python, Next.js, TypeScript, GraphQL"
    },
    {
      id: 4,
      title: "DevOps/SRE",
      description: "CI/CD, Terraform, Jenkins, Monitoring, Infrastructure as Code"
    },
    {
      id: 5,
      title: "Data Engineers",
      description: "Spark, Hadoop, ETL, Data Pipelines, Snowflake, Databricks"
    },
    {
      id: 6,
      title: "Cybersecurity Experts",
      description: "Penetration Testing, SIEM, Zero Trust, Compliance, IAM"
    },
    {
      id: 7,
      title: "Blockchain Developers",
      description: "Smart Contracts, Solidity, Web3, DeFi, Ethereum, Polygon"
    },
    {
      id: 8,
      title: "Mobile Developers",
      description: "iOS (Swift), Android (Kotlin), React Native, Flutter"
    }
  ],
  management: [
    {
      id: 9,
      title: "Product Managers",
      description: "Roadmap Planning, Agile, Stakeholder Management, Market Analysis"
    },
    {
      id: 10,
      title: "Engineering Managers",
      description: "Team Leadership, Sprint Planning, Performance Management"
    },
    {
      id: 11,
      title: "Scrum Masters",
      description: "Agile Coaching, Sprint Facilitation, Team Coordination"
    },
    {
      id: 12,
      title: "Technical Project Managers",
      description: "SDLC, Risk Management, Cross-functional Coordination"
    }
  ],
  leadership: [
    {
      id: 13,
      title: "Fractional CTOs",
      description: "Technical Strategy, Architecture Design, Team Building"
    },
    {
      id: 14,
      title: "VP of Engineering",
      description: "Organizational Scaling, Technology Roadmap, Budget Planning"
    },
    {
      id: 15,
      title: "Head of Product",
      description: "Product Vision, Go-to-Market Strategy, Innovation Leadership"
    },
    {
      id: 16,
      title: "Technology Consultants",
      description: "Digital Transformation, System Integration, Strategic Advisory"
    }
  ]
};

export const problems = [
  {
    id: 1,
    title: "Slow Process",
    description: "1-4 weeks to close a single position",
    icon: "timer-off"
  },
  {
    id: 2,
    title: "Expensive Markups",
    description: "15-25% agency fees eating your budget",
    icon: "trending-up"
  },
  {
    id: 3,
    title: "Manual Overhead",
    description: "Compliance, vetting, timesheets all manual",
    icon: "file-text"
  },
  {
    id: 4,
    title: "High Platform Fees",
    description: "Marketplaces charge 5-15% with limited control",
    icon: "alert-circle"
  }
];

export const solutions = [
  {
    id: 1,
    title: "Speed & Agility",
    description: "Talent matching in 72 hours, not weeks",
    icon: "zap",
    benefit: "10x Faster"
  },
  {
    id: 2,
    title: "Cost Transparency",
    description: "$10 onboarding + $1/hour. No hidden markups.",
    icon: "dollar-sign",
    benefit: "Save 20%"
  },
  {
    id: 3,
    title: "Quality Vetting",
    description: "Rigorous technical assessments and background verification",
    icon: "check-circle",
    benefit: "Top 5% Talent"
  },
  {
    id: 4,
    title: "Full Control",
    description: "Direct engagement with complete oversight",
    icon: "shield-check",
    benefit: "Your Rules"
  }
];

export const hiringProcess = [
  {
    step: 1,
    title: "Define Your Needs",
    description: "Tell us your requirements, tech stack, and timeline"
  },
  {
    step: 2,
    title: "Meet Vetted Talent",
    description: "Review pre-qualified candidates within 24-48 hours"
  },
  {
    step: 3,
    title: "Start Working",
    description: "Automated onboarding, contracts, and compliance"
  },
  {
    step: 4,
    title: "Manage Seamlessly",
    description: "Track hours, approve timesheets, and pay with ease"
  }
];

export const talentProcess = [
  {
    step: 1,
    title: "Apply Online",
    description: "Submit your profile with skills and experience"
  },
  {
    step: 2,
    title: "Get Vetted",
    description: "Technical assessment and background verification"
  },
  {
    step: 3,
    title: "Match with Projects",
    description: "Connect with companies seeking your expertise"
  },
  {
    step: 4,
    title: "Earn More",
    description: "Keep more of your rate with automated invoicing"
  }
];

export const faqData = [
  {
    question: "How is Mapeach different from traditional staffing agencies?",
    answer: "Traditional agencies charge 15-25% markups and take 1-4 weeks to close positions. Mapeach charges a transparent $10 onboarding fee + $1/hour, with talent matching in 72 hours average."
  },
  {
    question: "What is your pricing model?",
    answer: "We charge a one-time $10 fee per contractor onboarding and a recurring $1/hour fee billed bi-weekly. No hidden markups or surprise costs."
  },
  {
    question: "How do you vet your talent?",
    answer: "Every professional undergoes technical assessments, background checks, and reference verification. We ensure they meet industry standards before joining our network."
  },
  {
    question: "Can I hire talent for full-time positions?",
    answer: "Yes! While we specialize in contract and fractional roles, our platform supports full-time direct hires as well."
  },
  {
    question: "How quickly can I get candidates?",
    answer: "Most clients receive qualified candidate profiles within 24-48 hours, with an average time-to-hire of 72 hours."
  }
];